const HeaderVariant = {
  HEADER: 0,
  HEADER_WITH_STATS: 1,
};

export default HeaderVariant;
